<template>
  <v-app-bar app color="primary" dark role="banner">
    <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
    <v-app-bar-title id="app-title" class="d-flex align-center">
      <img v-if="logoUrl" :src="logoUrl" :alt="$t('app.title')" class="app-logo" />
    </v-app-bar-title>
    <v-spacer></v-spacer>
    <v-text-field
      v-model="search"
      :label="$t('app.search')"
      variant="outlined"
      density="comfortable"
      single-line
      hide-details
      class="mr-4 mt-1"
      style="max-width: 300px"
    ></v-text-field>
    <LanguageSwitcher class="mr-2" />
    <v-menu v-model="menuOpen" offset-y :close-on-content-click="true">
      <template #activator="{ props }">
        <v-btn v-bind="props" icon>
          <v-avatar size="36">
            <v-icon>mdi-account-circle</v-icon>
          </v-avatar>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="viewProfile">
          <v-list-item-title>{{ $t('navigation.profile') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>{{ $t('navigation.logout') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores/auth';
import { useDrawerStore } from '@/stores/drawer';
import { useNotification } from '@/composables/useNotification';
import { useProjectConfigStore } from '@/stores/projectConfig';
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue';

const router = useRouter();
const projectConfigStore = useProjectConfigStore();
const logoUrl = computed(() => projectConfigStore.logoUrl);
const authStore = useAuthStore();
const drawerStore = useDrawerStore();
const { t } = useI18n();
const { showInfo } = useNotification();
const search = ref('');
const menuOpen = ref(false);

const toggleDrawer = () => {
  drawerStore.toggle();
};

const viewProfile = () => {
  menuOpen.value = false;
  router.push('/profile');
};

const logout = () => {
  console.log('Logout button clicked');
  menuOpen.value = false;
  authStore.logout();

  // Show logout notification
  showInfo(t('auth.logoutSuccessful'));

  console.log('Auth store logout called, redirecting to login');
  router.push('/login');
};
</script>

<style scoped>
.app-logo {
  max-height: 48px;
  object-fit: contain;
}
</style>
